export default "__VITE_ASSET__26hTVISs__"